import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// Lazy load components
const Home = lazy(() => import('../components/landing/home/Home'));
const EmailDesignTesting = lazy(() => import('../components/landing/features/EmailDesignTesting'));
const EmailAnalytics = lazy(() => import('../components/landing/features/EmailAnalytics'));
const InboxSpamTesting = lazy(() => import('../components/landing/features/InboxSpamTesting'));
const WhiteLabelApi = lazy(() => import('../components/landing/features/WhiteLabelApi'));
// const EmailEditor = lazy(() => import('../components/landing/features/EmailEditor'));
const Pricing = lazy(() => import('../components/landing/pricing/Pricing'));
const About = lazy(() => import('../components/landing/about/About'));
const Contact = lazy(() => import('../components/landing/contacts/Contact'));
const WhatIsEmailTesting = lazy(() => import('../components/landing/articles/WhatIsEmailTesting'));
const Policy = lazy(() => import('../components/landing/policy/Policy'));
const Register = lazy(() => import('../components/landing/signup/Register'));
const NotFound = lazy(() => import('../components/landing/NotFound'));
const SignUpActivation = lazy(() => import('../components/landing/signup/SignUpActivation'));
const BlogList = lazy(() => import('../components/landing/blog/BlogList'));
const BlogPost = lazy(() => import('../components/landing/blog/BlogPost'));


export const routes = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/blog',
    element: <BlogList />,
  },
  {
    path: '/blog/:slug',
    element: <BlogPost />,
  },

  {
    path: '/features/email-design-testing',
    element: <EmailDesignTesting />,
  },
  {
    path: '/features/email-analytic',
    element: <EmailAnalytics />,
  },
  {
    path: '/features/inbox-spam-testing',
    element: <InboxSpamTesting />,
  },
  {
    path: '/features/white-label-api',
    element: <WhiteLabelApi />,
  },
  // {
  //   path: '/features/email-editor',
  //   element: <EmailEditor />,
  // },
  {
    path: '/pricing',
    element: <Pricing />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/articles/what-is-email-testing',
    element: <WhatIsEmailTesting />,
  },
  {
    path: '/policy/:name',
    element: <Policy />,
  },
  {
    path: '/user/register',
    element: <Register />,
  },
  {
    path: '/signup/activate/:token',
    element: <SignUpActivation />,
  },
  {
    path: '/404',
    element: <NotFound />,
  },
  {
    path: '*',
    element: <Navigate to="/404" replace />,
  },
];
